var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:#171926;}.c{stroke:#171926;stroke-width:0.8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-23834 -22440)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23834 22440)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4161.5 -17918)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19670.5 -4519)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.244,31a6.244,6.244,0,1,0,6.244,6.244A6.244,6.244,0,0,0,8.244,31Zm0,11.654a5.41,5.41,0,1,1,5.41-5.41,5.41,5.41,0,0,1-5.41,5.41Z",
    transform: "translate(-2 -19.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.059,6.33H26.314V3.418A.418.418,0,0,0,25.9,3H10.082A2.084,2.084,0,0,0,8,5.082v9.111a.418.418,0,0,0,.836,0V6.746a2.222,2.222,0,0,0,1.248.418H29.641v4.994H26.314a2.914,2.914,0,1,0,0,5.827h3.328v4.993H18.809a.418.418,0,0,0,0,.836h11.25a.418.418,0,0,0,.418-.418V6.746A.418.418,0,0,0,30.059,6.33Zm-19.979,0a1.249,1.249,0,1,1,0-2.5h15.4v2.5ZM26.314,17.152a2.082,2.082,0,1,1,0-4.162h3.328v4.162Z",
    transform: "translate(-5.294 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M49.886,29a.886.886,0,1,0,.886.886A.886.886,0,0,0,49.886,29Zm0,1.18a.295.295,0,1,1,.295-.295A.295.295,0,0,1,49.886,30.18Z",
    transform: "translate(-28.866 -17.814)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.791-8.016a2.243,2.243,0,0,1-1.5.67A1.713,1.713,0,0,1,2.806-8.18H4.7v-.6H2.578a2.121,2.121,0,0,1-.027-.32,1.505,1.505,0,0,1,.033-.335H4.7v-.614H2.816a1.724,1.724,0,0,1,1.48-.809,2.074,2.074,0,0,1,1.5.744l.745-.919a3.227,3.227,0,0,0-2.257-.948A2.969,2.969,0,0,0,1.4-10.052H.51v.614h.736c-.008.115-.017.23-.017.352s.008.213.017.31H.51v.6h.859a2.929,2.929,0,0,0,2.86,2.009A3.32,3.32,0,0,0,6.538-7.185Z",
    transform: "translate(2.188 27.441)"
  }))))));
};
export default SvgWallet;